module.exports = __webpack_public_path__ + "img/specie1.4cf5be4e.png";